import { environment } from '@environments/environment';
import { ActionReducer, ActionReducerMap, MetaReducer } from '@ngrx/store';
import * as fromSalesState from './sales-store/reducers/sales.reducer';

export interface State {
  sales: fromSalesState.State;
}

export const reducers: ActionReducerMap<State> = {
  sales: fromSalesState.reducer,
};

export const metaReducers: MetaReducer<State>[] = !environment.production ? [debug] : [];

export function debug(reducer: ActionReducer<any>): ActionReducer<any> {
  return function (state, action) {
    /* eslint no-console: 0 */
    console.log('state', state);
    console.log('action', action);

    return reducer(state, action);
  };
}
